import {
  createViewerCreditsSlot,
  getTenantViewerAssets
} from '@coosmo/shared-utils/tenant-assets-service'

let creditsSlotController = null

function getCustomUINameFromUrl() {
  return new URLSearchParams(window.location.search).get('customUIName')
}

async function renderCreditsBox() {
  const widgetContainer = document.getElementById('widgetContainer')
  if (!widgetContainer) return

  creditsSlotController?.destroy()
  const assets = getTenantViewerAssets({ tenantName: getCustomUINameFromUrl() })
  creditsSlotController = createViewerCreditsSlot({
    target: widgetContainer,
    assets,
    attributes: {
      root: {
        id: 'creditsBoxWidget',
        class: 'creditsBoxWidget'
      },
      image: {
        id: 'creditsBoxImage',
        class: 'creditsBoxImage'
      }
    }
  })

  await creditsSlotController.ready
}

export default { renderCreditsBox }
